import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';


@Component({
    selector: 'eas-editor-booking-item-bulk-name-search-replace',
    templateUrl: './editor-booking-item-bulk-name-search-replace.component.html',
    styleUrls: ['./editor-booking-item-bulk-name-search-replace.component.css'],
    standalone: false
})
export class EditorBookingItemBulkNameSearchReplaceComponent implements OnInit {
  @Input() namesReplaced: number;
  @Output() searchAndReplace = new EventEmitter<{ search: string, replace: string }>();

  form: FormGroup;

  lastSearch: { search: string, replace: string };

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group(
    { search: [''], replace: [''] }
    );
  }

  ngOnInit() {

  }

  onSubmit() {
    this.lastSearch = {
      search: this.form.value.search,
      replace: this.form.value.replace === null ? '' : this.form.value.replace
    };
    this.searchAndReplace.emit(this.lastSearch);
    this.form.reset();
  }
}
